import { Box, Typography } from "@husqvarna/ui-core";
import { FormattedMessage } from "react-intl";
import { NavLink, To } from "react-router-dom";
import clsx from "clsx";
import "./NavigationItem.scss";

export type NavigationProps = {
  i18nKey: string;
  to: To;
  defaultMessage?: string;
};

const Navigation = ({
  i18nKey,
  to,
  defaultMessage,
}: NavigationProps) => (
    <NavLink to={to} className={({ isActive }) => clsx(
      "tcsp-navigation__item", {
        "tcsp-navigation__item--active": isActive,
      }
    )}>
      <Box className="tcsp-navigation__item-box">
        <Typography variant="Subtitle2" className="tcsp-navigation__item-text" tag="span">
          <FormattedMessage id={i18nKey} defaultMessage={defaultMessage} />
        </Typography>
      </Box>
    </NavLink>
);

export default Navigation;